import type { SuperTab } from './types';

const PATH_TO_TAB: Record<string, SuperTab> = {
  '/super-admin': 'overview',
  '/super-admin/analytics': 'analytics',
  '/super-admin/tenants': 'tenants',
  '/super-admin/landing': 'landing',
  '/super-admin/voz': 'voice',
  '/super-admin/planos': 'plans',
  '/super-admin/comunicados': 'broadcasts',
  '/super-admin/plataforma': 'platform',
  '/super-admin/auditoria': 'audit',
  '/super-admin/sistema': 'system',
};

export function tabFromPath(pathname: string): SuperTab {
  const path = pathname.replace(/\/$/, '') || '/super-admin';
  return PATH_TO_TAB[path] ?? 'overview';
}

export function isSuperAdminAuthPath(pathname: string): boolean {
  return pathname.startsWith('/super-admin/auth');
}
